import React from "react";
import "office-ui-fabric-core/dist/css/fabric.css";

const FabricIcon = props => (
	<i className={`ms-Icon ms-Icon--${props.iconName}`} {...props}></i>
);

export default FabricIcon;
